/**
 * Auto-generated select icon components
 * Generated by: npx tsx scripts/generate-select-icons.ts
 */

import type { ComponentType, SVGProps } from "react";

import { IconAmazon } from "./icons/amazon";
import { IconBlack3Packages } from "./icons/black-3-packages";
import { IconBlack3PackagesAlt } from "./icons/black-3-packages-alt";
import { IconBlackAmazonSquare } from "./icons/black-amazon-square";
import { IconBlackArrowRight } from "./icons/black-arrow-right";
import { IconBlackArrowsRightLeft } from "./icons/black-arrows-right-left";
import { IconBlackBankNote } from "./icons/black-bank-note";
import { IconBlackBarrier } from "./icons/black-barrier";
import { IconBlackBenchmarks } from "./icons/black-benchmarks";
import { IconBlackBookOpen } from "./icons/black-book-open";
import { IconBlackBriefcase } from "./icons/black-briefcase";
import { IconBlackCart } from "./icons/black-cart";
import { IconBlackCoinDollar } from "./icons/black-coin-dollar";
import { IconBlackFastTime } from "./icons/black-fast-time";
import { IconBlackFinger } from "./icons/black-finger";
import { IconBlackFlag } from "./icons/black-flag";
import { IconBlackGlobe } from "./icons/black-globe";
import { IconBlackHeadset } from "./icons/black-headset";
import { IconBlackLiquidDollar } from "./icons/black-liquid-dollar";
import { IconBlackListPerson } from "./icons/black-list-person";
import { IconBlackMoneyCash } from "./icons/black-money-cash";
import { IconBlackNavAppDeveloper } from "./icons/black-nav-app-developer";
import { IconBlackNavConsumerServices } from "./icons/black-nav-consumer-services";
import { IconBlackNavHealthcare } from "./icons/black-nav-healthcare";
import { IconBlackNavProfessionalServices } from "./icons/black-nav-professional-services";
import { IconBlackNavSaas } from "./icons/black-nav-saas";
import { IconBlackPackage } from "./icons/black-package";
import { IconBlackPartnerships } from "./icons/black-partnerships";
import { IconBlackPeople2 } from "./icons/black-people-2";
import { IconBlackPieSlash } from "./icons/black-pie-slash";
import { IconBlackPin } from "./icons/black-pin";
import { IconBlackRocketLaunch } from "./icons/black-rocket-launch";
import { IconBlackStorefront } from "./icons/black-storefront";
import { IconBlackStorefrontAlt } from "./icons/black-storefront-alt";
import { IconBlackThreeArrows } from "./icons/black-three-arrows";
import { IconBlackThreeArrowsAlt } from "./icons/black-three-arrows-alt";
import { IconBlackThunder } from "./icons/black-thunder";
import { IconBlackTicTacToe } from "./icons/black-tic-tac-toe";
import { IconBlackUmbrella } from "./icons/black-umbrella";
import { IconBlackWaveArrowUp } from "./icons/black-wave-arrow-up";
import { IconBlue3Packages } from "./icons/blue-3-packages";
import { IconBlue3PackagesAlt } from "./icons/blue-3-packages-alt";
import { IconBlueArrowRight } from "./icons/blue-arrow-right";
import { IconBlueArrowRightBase } from "./icons/blue-arrow-right-base";
import { IconBlueArrows } from "./icons/blue-arrows";
import { IconBlueBankNote } from "./icons/blue-bank-note";
import { IconBlueBarrier } from "./icons/blue-barrier";
import { IconBlueCart } from "./icons/blue-cart";
import { IconBlueCartBase } from "./icons/blue-cart-base";
import { IconBlueChatbubbleSmile } from "./icons/blue-chatbubble-smile";
import { IconBlueClock } from "./icons/blue-clock";
import { IconBlueCoinDollar } from "./icons/blue-coin-dollar";
import { IconBlueFastTime } from "./icons/blue-fast-time";
import { IconBlueFinger } from "./icons/blue-finger";
import { IconBlueFlag } from "./icons/blue-flag";
import { IconBlueGlobe } from "./icons/blue-globe";
import { IconBlueHeadset } from "./icons/blue-headset";
import { IconBlueLiquidDollar } from "./icons/blue-liquid-dollar";
import { IconBlueMoney } from "./icons/blue-money";
import { IconBlueMoneyBag } from "./icons/blue-money-bag";
import { IconBlueMoneyCash } from "./icons/blue-money-cash";
import { IconBluePackage } from "./icons/blue-package";
import { IconBluePackageBase } from "./icons/blue-package-base";
import { IconBluePieSlash } from "./icons/blue-pie-slash";
import { IconBluePin } from "./icons/blue-pin";
import { IconBluePosition } from "./icons/blue-position";
import { IconBlueShield } from "./icons/blue-shield";
import { IconBlueStorefront } from "./icons/blue-storefront";
import { IconBlueStorefrontAlt } from "./icons/blue-storefront-alt";
import { IconBlueTarget } from "./icons/blue-target";
import { IconBlueThreeArrows } from "./icons/blue-three-arrows";
import { IconBlueThunder } from "./icons/blue-thunder";
import { IconBlueTicTacToe } from "./icons/blue-tic-tac-toe";
import { IconBlueUmbrella } from "./icons/blue-umbrella";
import { IconBlueWaveArrowUp } from "./icons/blue-wave-arrow-up";
import { IconBlueWaveDollar } from "./icons/blue-wave-dollar";
import { IconDarkBlueBag } from "./icons/dark-blue-bag";
import { IconDarkBlueCart } from "./icons/dark-blue-cart";
import { IconDarkBlueGlob } from "./icons/dark-blue-glob";
import { IconDarkBlueThreeArrows } from "./icons/dark-blue-three-arrows";
import { IconDarkPurpleAtmWithdrawal } from "./icons/dark-purple-atm-withdrawal";
import { IconDarkPurpleBenchmarks } from "./icons/dark-purple-benchmarks";
import { IconDarkPurpleChartBars } from "./icons/dark-purple-chart-bars";
import { IconDarkPurpleDocuments } from "./icons/dark-purple-documents";
import { IconDarkPurpleFunding } from "./icons/dark-purple-funding";
import { IconDarkPurpleHandBanknote } from "./icons/dark-purple-hand-banknote";
import { IconDarkPurpleLightbulb } from "./icons/dark-purple-lightbulb";
import { IconDarkPurpleListPerson } from "./icons/dark-purple-list-person";
import { IconDarkPurpleMoneybagDollar } from "./icons/dark-purple-moneybag-dollar";
import { IconDarkPurplePaymentCardCheck } from "./icons/dark-purple-payment-card-check";
import { IconDarkPurplePeople3 } from "./icons/dark-purple-people-3";
import { IconDarkPurplePersonCheck } from "./icons/dark-purple-person-check";
import { IconDarkPurplePersonSquare } from "./icons/dark-purple-person-square";
import { IconDarkPurpleRocketLaunch } from "./icons/dark-purple-rocket-launch";
import { IconDarkPurpleShieldCheck } from "./icons/dark-purple-shield-check";
import { IconDarkPurpleShoppingCart } from "./icons/dark-purple-shopping-cart";
import { IconDarkPurpleStar } from "./icons/dark-purple-star";
import { IconEarth } from "./icons/earth";
import { IconFastTime } from "./icons/fast-time";
import { IconGrayOne } from "./icons/gray-one";
import { IconGrayThree } from "./icons/gray-three";
import { IconGrayTwo } from "./icons/gray-two";
import { IconInlineGlobe } from "./icons/inline-globe";
import { IconPerson } from "./icons/person";
import { IconPurple3Packages } from "./icons/purple-3-packages";
import { IconPurpleArrowRight } from "./icons/purple-arrow-right";
import { IconPurpleBankNote } from "./icons/purple-bank-note";
import { IconPurpleBarrier } from "./icons/purple-barrier";
import { IconPurpleBookLock } from "./icons/purple-book-lock";
import { IconPurpleCart } from "./icons/purple-cart";
import { IconPurpleClock } from "./icons/purple-clock";
import { IconPurpleCoinDollar } from "./icons/purple-coin-dollar";
import { IconPurpleCoins } from "./icons/purple-coins";
import { IconPurpleDocMagnifyingGlass } from "./icons/purple-doc-magnifying-glass";
import { IconPurpleDollarCircle } from "./icons/purple-dollar-circle";
import { IconPurpleFastTime } from "./icons/purple-fast-time";
import { IconPurpleFinger } from "./icons/purple-finger";
import { IconPurpleFlag } from "./icons/purple-flag";
import { IconPurpleGlobe } from "./icons/purple-globe";
import { IconPurpleGrow } from "./icons/purple-grow";
import { IconPurpleLiquidDollar } from "./icons/purple-liquid-dollar";
import { IconPurpleLotOfCash } from "./icons/purple-lot-of-cash";
import { IconPurpleMoneyCash } from "./icons/purple-money-cash";
import { IconPurplePackage } from "./icons/purple-package";
import { IconPurplePcCheck } from "./icons/purple-pc-check";
import { IconPurplePieSlash } from "./icons/purple-pie-slash";
import { IconPurplePin } from "./icons/purple-pin";
import { IconPurpleStorefront } from "./icons/purple-storefront";
import { IconPurpleThreeArrows } from "./icons/purple-three-arrows";
import { IconPurpleThunder } from "./icons/purple-thunder";
import { IconPurpleTicTacToe } from "./icons/purple-tic-tac-toe";
import { IconPurpleUmbrella } from "./icons/purple-umbrella";
import { IconPurpleWaveArrowUp } from "./icons/purple-wave-arrow-up";
import { IconUmbrella } from "./icons/umbrella";
import { IconUsa } from "./icons/usa";
import { IconWhite3Packages } from "./icons/white-3-packages";
import { IconWhiteArrowRight } from "./icons/white-arrow-right";
import { IconWhiteBankNote } from "./icons/white-bank-note";
import { IconWhiteBarrier } from "./icons/white-barrier";
import { IconWhiteCart } from "./icons/white-cart";
import { IconWhiteCoinDollar } from "./icons/white-coin-dollar";
import { IconWhiteFastTime } from "./icons/white-fast-time";
import { IconWhiteFinger } from "./icons/white-finger";
import { IconWhiteFlag } from "./icons/white-flag";
import { IconWhiteGlobe } from "./icons/white-globe";
import { IconWhiteLiquidDollar } from "./icons/white-liquid-dollar";
import { IconWhiteMoneyCash } from "./icons/white-money-cash";
import { IconWhitePackage } from "./icons/white-package";
import { IconWhitePieSlash } from "./icons/white-pie-slash";
import { IconWhitePin } from "./icons/white-pin";
import { IconWhiteStorefront } from "./icons/white-storefront";
import { IconWhiteThreeArrows } from "./icons/white-three-arrows";
import { IconWhiteThunder } from "./icons/white-thunder";
import { IconWhiteTicTacToe } from "./icons/white-tic-tac-toe";
import { IconWhiteUmbrella } from "./icons/white-umbrella";
import { IconWhiteWaveArrowUp } from "./icons/white-wave-arrow-up";

// Re-export all icons
export {
  IconAmazon,
  IconBlack3PackagesAlt,
  IconBlack3Packages,
  IconBlackAmazonSquare,
  IconBlackArrowRight,
  IconBlackArrowsRightLeft,
  IconBlackBankNote,
  IconBlackBarrier,
  IconBlackBenchmarks,
  IconBlackBookOpen,
  IconBlackBriefcase,
  IconBlackCart,
  IconBlackCoinDollar,
  IconBlackFastTime,
  IconBlackFinger,
  IconBlackFlag,
  IconBlackGlobe,
  IconBlackHeadset,
  IconBlackLiquidDollar,
  IconBlackListPerson,
  IconBlackMoneyCash,
  IconBlackNavAppDeveloper,
  IconBlackNavConsumerServices,
  IconBlackNavHealthcare,
  IconBlackNavProfessionalServices,
  IconBlackNavSaas,
  IconBlackPackage,
  IconBlackPartnerships,
  IconBlackPeople2,
  IconBlackPieSlash,
  IconBlackPin,
  IconBlackRocketLaunch,
  IconBlackStorefrontAlt,
  IconBlackStorefront,
  IconBlackThreeArrowsAlt,
  IconBlackThreeArrows,
  IconBlackThunder,
  IconBlackTicTacToe,
  IconBlackUmbrella,
  IconBlackWaveArrowUp,
  IconBlue3PackagesAlt,
  IconBlue3Packages,
  IconBlueArrowRightBase,
  IconBlueArrowRight,
  IconBlueArrows,
  IconBlueBankNote,
  IconBlueBarrier,
  IconBlueCartBase,
  IconBlueCart,
  IconBlueChatbubbleSmile,
  IconBlueClock,
  IconBlueCoinDollar,
  IconBlueFastTime,
  IconBlueFinger,
  IconBlueFlag,
  IconBlueGlobe,
  IconBlueHeadset,
  IconBlueLiquidDollar,
  IconBlueMoneyBag,
  IconBlueMoneyCash,
  IconBlueMoney,
  IconBluePackageBase,
  IconBluePackage,
  IconBluePieSlash,
  IconBluePin,
  IconBluePosition,
  IconBlueShield,
  IconBlueStorefrontAlt,
  IconBlueStorefront,
  IconBlueTarget,
  IconBlueThreeArrows,
  IconBlueThunder,
  IconBlueTicTacToe,
  IconBlueUmbrella,
  IconBlueWaveArrowUp,
  IconBlueWaveDollar,
  IconDarkBlueBag,
  IconDarkBlueCart,
  IconDarkBlueGlob,
  IconDarkBlueThreeArrows,
  IconDarkPurpleAtmWithdrawal,
  IconDarkPurpleBenchmarks,
  IconDarkPurpleChartBars,
  IconDarkPurpleDocuments,
  IconDarkPurpleFunding,
  IconDarkPurpleHandBanknote,
  IconDarkPurpleLightbulb,
  IconDarkPurpleListPerson,
  IconDarkPurpleMoneybagDollar,
  IconDarkPurplePaymentCardCheck,
  IconDarkPurplePeople3,
  IconDarkPurplePersonCheck,
  IconDarkPurplePersonSquare,
  IconDarkPurpleRocketLaunch,
  IconDarkPurpleShieldCheck,
  IconDarkPurpleShoppingCart,
  IconDarkPurpleStar,
  IconEarth,
  IconFastTime,
  IconGrayOne,
  IconGrayThree,
  IconGrayTwo,
  IconInlineGlobe,
  IconPerson,
  IconPurple3Packages,
  IconPurpleArrowRight,
  IconPurpleBankNote,
  IconPurpleBarrier,
  IconPurpleBookLock,
  IconPurpleCart,
  IconPurpleClock,
  IconPurpleCoinDollar,
  IconPurpleCoins,
  IconPurpleDocMagnifyingGlass,
  IconPurpleDollarCircle,
  IconPurpleFastTime,
  IconPurpleFinger,
  IconPurpleFlag,
  IconPurpleGlobe,
  IconPurpleGrow,
  IconPurpleLiquidDollar,
  IconPurpleLotOfCash,
  IconPurpleMoneyCash,
  IconPurplePackage,
  IconPurplePcCheck,
  IconPurplePieSlash,
  IconPurplePin,
  IconPurpleStorefront,
  IconPurpleThreeArrows,
  IconPurpleThunder,
  IconPurpleTicTacToe,
  IconPurpleUmbrella,
  IconPurpleWaveArrowUp,
  IconUmbrella,
  IconUsa,
  IconWhite3Packages,
  IconWhiteArrowRight,
  IconWhiteBankNote,
  IconWhiteBarrier,
  IconWhiteCart,
  IconWhiteCoinDollar,
  IconWhiteFastTime,
  IconWhiteFinger,
  IconWhiteFlag,
  IconWhiteGlobe,
  IconWhiteLiquidDollar,
  IconWhiteMoneyCash,
  IconWhitePackage,
  IconWhitePieSlash,
  IconWhitePin,
  IconWhiteStorefront,
  IconWhiteThreeArrows,
  IconWhiteThunder,
  IconWhiteTicTacToe,
  IconWhiteUmbrella,
  IconWhiteWaveArrowUp,
};

// Icon ID type
export type IconId =
  | "amazon"
  | "black-3-packages-alt"
  | "black-3-packages"
  | "black-amazon-square"
  | "black-arrow-right"
  | "black-arrows-right-left"
  | "black-bank-note"
  | "black-barrier"
  | "black-benchmarks"
  | "black-book-open"
  | "black-briefcase"
  | "black-cart"
  | "black-coin-dollar"
  | "black-fast-time"
  | "black-finger"
  | "black-flag"
  | "black-globe"
  | "black-headset"
  | "black-liquid-dollar"
  | "black-list-person"
  | "black-money-cash"
  | "black-nav-app-developer"
  | "black-nav-consumer-services"
  | "black-nav-healthcare"
  | "black-nav-professional-services"
  | "black-nav-saas"
  | "black-package"
  | "black-partnerships"
  | "black-people-2"
  | "black-pie-slash"
  | "black-pin"
  | "black-rocket-launch"
  | "black-storefront-alt"
  | "black-storefront"
  | "black-three-arrows-alt"
  | "black-three-arrows"
  | "black-thunder"
  | "black-tic-tac-toe"
  | "black-umbrella"
  | "black-wave-arrow-up"
  | "blue-3-packages-alt"
  | "blue-3-packages"
  | "blue-arrow-right-base"
  | "blue-arrow-right"
  | "blue-arrows"
  | "blue-bank-note"
  | "blue-barrier"
  | "blue-cart-base"
  | "blue-cart"
  | "blue-chatbubble-smile"
  | "blue-clock"
  | "blue-coin-dollar"
  | "blue-fast-time"
  | "blue-finger"
  | "blue-flag"
  | "blue-globe"
  | "blue-headset"
  | "blue-liquid-dollar"
  | "blue-money-bag"
  | "blue-money-cash"
  | "blue-money"
  | "blue-package-base"
  | "blue-package"
  | "blue-pie-slash"
  | "blue-pin"
  | "blue-position"
  | "blue-shield"
  | "blue-storefront-alt"
  | "blue-storefront"
  | "blue-target"
  | "blue-three-arrows"
  | "blue-thunder"
  | "blue-tic-tac-toe"
  | "blue-umbrella"
  | "blue-wave-arrow-up"
  | "blue-wave-dollar"
  | "dark-blue-bag"
  | "dark-blue-cart"
  | "dark-blue-glob"
  | "dark-blue-three-arrows"
  | "dark-purple-atm-withdrawal"
  | "dark-purple-benchmarks"
  | "dark-purple-chart-bars"
  | "dark-purple-documents"
  | "dark-purple-funding"
  | "dark-purple-hand-banknote"
  | "dark-purple-lightbulb"
  | "dark-purple-list-person"
  | "dark-purple-moneybag-dollar"
  | "dark-purple-payment-card-check"
  | "dark-purple-people-3"
  | "dark-purple-person-check"
  | "dark-purple-person-square"
  | "dark-purple-rocket-launch"
  | "dark-purple-shield-check"
  | "dark-purple-shopping-cart"
  | "dark-purple-star"
  | "earth"
  | "fast-time"
  | "gray-one"
  | "gray-three"
  | "gray-two"
  | "inline-globe"
  | "person"
  | "purple-3-packages"
  | "purple-arrow-right"
  | "purple-bank-note"
  | "purple-barrier"
  | "purple-book-lock"
  | "purple-cart"
  | "purple-clock"
  | "purple-coin-dollar"
  | "purple-coins"
  | "purple-doc-magnifying-glass"
  | "purple-dollar-circle"
  | "purple-fast-time"
  | "purple-finger"
  | "purple-flag"
  | "purple-globe"
  | "purple-grow"
  | "purple-liquid-dollar"
  | "purple-lot-of-cash"
  | "purple-money-cash"
  | "purple-package"
  | "purple-pc-check"
  | "purple-pie-slash"
  | "purple-pin"
  | "purple-storefront"
  | "purple-three-arrows"
  | "purple-thunder"
  | "purple-tic-tac-toe"
  | "purple-umbrella"
  | "purple-wave-arrow-up"
  | "umbrella"
  | "usa"
  | "white-3-packages"
  | "white-arrow-right"
  | "white-bank-note"
  | "white-barrier"
  | "white-cart"
  | "white-coin-dollar"
  | "white-fast-time"
  | "white-finger"
  | "white-flag"
  | "white-globe"
  | "white-liquid-dollar"
  | "white-money-cash"
  | "white-package"
  | "white-pie-slash"
  | "white-pin"
  | "white-storefront"
  | "white-three-arrows"
  | "white-thunder"
  | "white-tic-tac-toe"
  | "white-umbrella"
  | "white-wave-arrow-up";

// Component map for dynamic lookup
export const ICON_MAP: Record<
  IconId,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  amazon: IconAmazon,
  "black-3-packages-alt": IconBlack3PackagesAlt,
  "black-3-packages": IconBlack3Packages,
  "black-amazon-square": IconBlackAmazonSquare,
  "black-arrow-right": IconBlackArrowRight,
  "black-arrows-right-left": IconBlackArrowsRightLeft,
  "black-bank-note": IconBlackBankNote,
  "black-barrier": IconBlackBarrier,
  "black-benchmarks": IconBlackBenchmarks,
  "black-book-open": IconBlackBookOpen,
  "black-briefcase": IconBlackBriefcase,
  "black-cart": IconBlackCart,
  "black-coin-dollar": IconBlackCoinDollar,
  "black-fast-time": IconBlackFastTime,
  "black-finger": IconBlackFinger,
  "black-flag": IconBlackFlag,
  "black-globe": IconBlackGlobe,
  "black-headset": IconBlackHeadset,
  "black-liquid-dollar": IconBlackLiquidDollar,
  "black-list-person": IconBlackListPerson,
  "black-money-cash": IconBlackMoneyCash,
  "black-nav-app-developer": IconBlackNavAppDeveloper,
  "black-nav-consumer-services": IconBlackNavConsumerServices,
  "black-nav-healthcare": IconBlackNavHealthcare,
  "black-nav-professional-services": IconBlackNavProfessionalServices,
  "black-nav-saas": IconBlackNavSaas,
  "black-package": IconBlackPackage,
  "black-partnerships": IconBlackPartnerships,
  "black-people-2": IconBlackPeople2,
  "black-pie-slash": IconBlackPieSlash,
  "black-pin": IconBlackPin,
  "black-rocket-launch": IconBlackRocketLaunch,
  "black-storefront-alt": IconBlackStorefrontAlt,
  "black-storefront": IconBlackStorefront,
  "black-three-arrows-alt": IconBlackThreeArrowsAlt,
  "black-three-arrows": IconBlackThreeArrows,
  "black-thunder": IconBlackThunder,
  "black-tic-tac-toe": IconBlackTicTacToe,
  "black-umbrella": IconBlackUmbrella,
  "black-wave-arrow-up": IconBlackWaveArrowUp,
  "blue-3-packages-alt": IconBlue3PackagesAlt,
  "blue-3-packages": IconBlue3Packages,
  "blue-arrow-right-base": IconBlueArrowRightBase,
  "blue-arrow-right": IconBlueArrowRight,
  "blue-arrows": IconBlueArrows,
  "blue-bank-note": IconBlueBankNote,
  "blue-barrier": IconBlueBarrier,
  "blue-cart-base": IconBlueCartBase,
  "blue-cart": IconBlueCart,
  "blue-chatbubble-smile": IconBlueChatbubbleSmile,
  "blue-clock": IconBlueClock,
  "blue-coin-dollar": IconBlueCoinDollar,
  "blue-fast-time": IconBlueFastTime,
  "blue-finger": IconBlueFinger,
  "blue-flag": IconBlueFlag,
  "blue-globe": IconBlueGlobe,
  "blue-headset": IconBlueHeadset,
  "blue-liquid-dollar": IconBlueLiquidDollar,
  "blue-money-bag": IconBlueMoneyBag,
  "blue-money-cash": IconBlueMoneyCash,
  "blue-money": IconBlueMoney,
  "blue-package-base": IconBluePackageBase,
  "blue-package": IconBluePackage,
  "blue-pie-slash": IconBluePieSlash,
  "blue-pin": IconBluePin,
  "blue-position": IconBluePosition,
  "blue-shield": IconBlueShield,
  "blue-storefront-alt": IconBlueStorefrontAlt,
  "blue-storefront": IconBlueStorefront,
  "blue-target": IconBlueTarget,
  "blue-three-arrows": IconBlueThreeArrows,
  "blue-thunder": IconBlueThunder,
  "blue-tic-tac-toe": IconBlueTicTacToe,
  "blue-umbrella": IconBlueUmbrella,
  "blue-wave-arrow-up": IconBlueWaveArrowUp,
  "blue-wave-dollar": IconBlueWaveDollar,
  "dark-blue-bag": IconDarkBlueBag,
  "dark-blue-cart": IconDarkBlueCart,
  "dark-blue-glob": IconDarkBlueGlob,
  "dark-blue-three-arrows": IconDarkBlueThreeArrows,
  "dark-purple-atm-withdrawal": IconDarkPurpleAtmWithdrawal,
  "dark-purple-benchmarks": IconDarkPurpleBenchmarks,
  "dark-purple-chart-bars": IconDarkPurpleChartBars,
  "dark-purple-documents": IconDarkPurpleDocuments,
  "dark-purple-funding": IconDarkPurpleFunding,
  "dark-purple-hand-banknote": IconDarkPurpleHandBanknote,
  "dark-purple-lightbulb": IconDarkPurpleLightbulb,
  "dark-purple-list-person": IconDarkPurpleListPerson,
  "dark-purple-moneybag-dollar": IconDarkPurpleMoneybagDollar,
  "dark-purple-payment-card-check": IconDarkPurplePaymentCardCheck,
  "dark-purple-people-3": IconDarkPurplePeople3,
  "dark-purple-person-check": IconDarkPurplePersonCheck,
  "dark-purple-person-square": IconDarkPurplePersonSquare,
  "dark-purple-rocket-launch": IconDarkPurpleRocketLaunch,
  "dark-purple-shield-check": IconDarkPurpleShieldCheck,
  "dark-purple-shopping-cart": IconDarkPurpleShoppingCart,
  "dark-purple-star": IconDarkPurpleStar,
  earth: IconEarth,
  "fast-time": IconFastTime,
  "gray-one": IconGrayOne,
  "gray-three": IconGrayThree,
  "gray-two": IconGrayTwo,
  "inline-globe": IconInlineGlobe,
  person: IconPerson,
  "purple-3-packages": IconPurple3Packages,
  "purple-arrow-right": IconPurpleArrowRight,
  "purple-bank-note": IconPurpleBankNote,
  "purple-barrier": IconPurpleBarrier,
  "purple-book-lock": IconPurpleBookLock,
  "purple-cart": IconPurpleCart,
  "purple-clock": IconPurpleClock,
  "purple-coin-dollar": IconPurpleCoinDollar,
  "purple-coins": IconPurpleCoins,
  "purple-doc-magnifying-glass": IconPurpleDocMagnifyingGlass,
  "purple-dollar-circle": IconPurpleDollarCircle,
  "purple-fast-time": IconPurpleFastTime,
  "purple-finger": IconPurpleFinger,
  "purple-flag": IconPurpleFlag,
  "purple-globe": IconPurpleGlobe,
  "purple-grow": IconPurpleGrow,
  "purple-liquid-dollar": IconPurpleLiquidDollar,
  "purple-lot-of-cash": IconPurpleLotOfCash,
  "purple-money-cash": IconPurpleMoneyCash,
  "purple-package": IconPurplePackage,
  "purple-pc-check": IconPurplePcCheck,
  "purple-pie-slash": IconPurplePieSlash,
  "purple-pin": IconPurplePin,
  "purple-storefront": IconPurpleStorefront,
  "purple-three-arrows": IconPurpleThreeArrows,
  "purple-thunder": IconPurpleThunder,
  "purple-tic-tac-toe": IconPurpleTicTacToe,
  "purple-umbrella": IconPurpleUmbrella,
  "purple-wave-arrow-up": IconPurpleWaveArrowUp,
  umbrella: IconUmbrella,
  usa: IconUsa,
  "white-3-packages": IconWhite3Packages,
  "white-arrow-right": IconWhiteArrowRight,
  "white-bank-note": IconWhiteBankNote,
  "white-barrier": IconWhiteBarrier,
  "white-cart": IconWhiteCart,
  "white-coin-dollar": IconWhiteCoinDollar,
  "white-fast-time": IconWhiteFastTime,
  "white-finger": IconWhiteFinger,
  "white-flag": IconWhiteFlag,
  "white-globe": IconWhiteGlobe,
  "white-liquid-dollar": IconWhiteLiquidDollar,
  "white-money-cash": IconWhiteMoneyCash,
  "white-package": IconWhitePackage,
  "white-pie-slash": IconWhitePieSlash,
  "white-pin": IconWhitePin,
  "white-storefront": IconWhiteStorefront,
  "white-three-arrows": IconWhiteThreeArrows,
  "white-thunder": IconWhiteThunder,
  "white-tic-tac-toe": IconWhiteTicTacToe,
  "white-umbrella": IconWhiteUmbrella,
  "white-wave-arrow-up": IconWhiteWaveArrowUp,
};
